import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartFunnelCheckboxItemBlockConfig } from '@front-platform/content-builder';
import { cartFunnelCheckboxItemBlockResolveConfig } from '@front-platform/content-builder';
import { map, take } from 'rxjs/operators';
import { Component, OnInit, input } from '@angular/core';

import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
export interface CartFunnelCheckboxItemBlockRuntimeConfig {
  'block_id'?: string;
  'form_id'?: string;
}

export type CartFunnelCheckboxItemBlockConfigInput = Partial<
  Omit<CartFunnelCheckboxItemBlockConfig, keyof CartFunnelCheckboxItemBlockRuntimeConfig> &
    CartFunnelCheckboxItemBlockRuntimeConfig
>;
export type CartFunnelCheckboxItemBlockResolvedConfig = Omit<
  CartFunnelCheckboxItemBlockConfig,
  keyof CartFunnelCheckboxItemBlockRuntimeConfig
> &
  Partial<CartFunnelCheckboxItemBlockRuntimeConfig>;
export interface CartFunnelCheckboxItemBlockContract extends ConfigComponentContract<
  CartFunnelCheckboxItemBlockConfigInput,
  CartFunnelCheckboxItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-funnel-checkbox-item-block',
  templateUrl: './cart-funnel-checkbox-item-block.component.html',
  standalone: false,
})
export class CartFunnelCheckboxItemBlockComponent
  implements OnInit, CartFunnelCheckboxItemBlockContract
{
  readonly config = input<CartFunnelCheckboxItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartFunnelCheckboxItemBlockConfig,
    CartFunnelCheckboxItemBlockRuntimeConfig
  >(cartFunnelCheckboxItemBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get checked(): boolean {
    return this.resolvedConfig()['checked'] as unknown as boolean;
  }
  get required(): boolean {
    return this.resolvedConfig()['required'] as unknown as boolean;
  }
  get customTitle(): string | undefined {
    return this.resolvedConfig()['custom_title'] as unknown as string | undefined;
  }
  get displayCustomTitleInComment(): boolean {
    return this.resolvedConfig()['display_custom_title_in_comment'] as unknown as boolean;
  }
  get blockId(): string {
    return this.resolvedConfig()['block_id'] as unknown as string;
  }
  get formId(): string {
    return this.resolvedConfig()['form_id'] as unknown as string;
  }

  value = this.checked;

  constructor(
    private cartFunnelSelector: CartFunnelStoreSelector,
    private cartFunnelDispatcher: CartFunnelStoreDispatcher,
  ) {}

  ngOnInit(): void {
    this.cartFunnelDispatcher.addValue({
      id: this.blockId,
      title: this.title,
      displayTitle: true,
      formId: this.formId,
      required: this.required,
      customTitle: this.customTitle,
      displayCustomTitleInComment: this.displayCustomTitleInComment,
    });

    this.cartFunnelSelector
      .selectValue(this.blockId)
      .pipe(
        take(1),
        map(form => (this.value = form?.value === true)),
      )
      .subscribe();
  }

  onValueChange(_value: string | boolean): void {
    this.cartFunnelDispatcher.updateValue({
      id: this.blockId,
      changes: {
        value: _value,
      },
    });
  }

  forceType(data: any): any {
    return data as any;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartFunnelCheckboxItemBlockComponent, {
  'keyAliases': {},
});
